/*
Sohel 11/18/2022 2700453848 run Batch trigger Group changes
Sohel 11/18/2022 2700453848 Added Condition dynamic form
Sohel 11/19/2022 2700453848 Save API payload Changes
Akhila 11/23/2022 2700453848 change filter method field option label rendering only description
akhila 11/24/2022 2700453848 fixed action data.
Ashraf 11/24/2022 3031450488 passing props to dynamic fields
akhila 11/24/2022 2700453848 fixed validations
Rajesh 11/28/2022 2700453848 fixed fields render issue
Sohel 11/28/2022 2700453848 Added Condition in Date Payload
Poornima 11/29/2022 2700453848 API issues fixed for run trigger
Rajesh 11/29/2022 2700453848 validation for end date
Prakash 12/01/2022 2700453848 Added margin dense for field.
Rohini 12/08/2022 2700453848 alignment issue fix in textfield.
sai krishna 3/1/2023 2700453848 change code  and description
dilip 01/04/2023 2700453848 added mode field
Prakash 02/14/2023 2700453848 Implemented New UI Changes.
Ravi 03/01/2023 2700453848 Rename validation Disposition to Status
Ravi 03/30/2023 2700453848 fixed validation issue
Prakash 06/04/2023 2700453848 fixed alignments issue in responsive
Sohel 04/05/2022 2692790263 FIxed Filter Method Validation issue
Prakash 08/05/2023 2692790263 add theming classname.
Akhila 06/07/2023 2692790263 added breadcrum code and description
Akhila 06/20/2023 2692790263 modified account by list date action and field implemented Today or T
Sohel 10/11/2023 2692790263 Fixed Mode pre populate Issue
Sohel 10/16/2023 2692790263 Fixed Filter Method Default Select Issue
Sohel 10/16/2023 2692790263 Fixed Account by fields Date Values Issue
Sohel 10/18/2023 2692790263 Fixed Mode Update and Form Reset Issue
*/
import {Button, FormHelperText} from '@material-ui/core';
import React, {useEffect, useState, useContext, useRef} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {
  getActions,
  postFieldCode,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import {useDispatch, useSelector} from 'react-redux';
import GetAccessMethodFields from '../../ReportMaster/SearchReportMaster/GetAccessMethodFields';
import PageLoader from '../../../../components/PageLoader';
import * as yup from 'yup';
import {postRunReport} from '../../../../redux/reducers/TriggerGroup';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import BreadCrums from '../../../../util/BreadCrum';
const RunTriggerGroup = ({reportDialogData, rowData}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const formRef = useRef();
  const [fieldSubmitted, setSubmitted] = useState(false);
  const {isLoading, promptData, fieldCodeData, actionData} = useSelector(
    ({addReportMaster}) => addReportMaster,
  );
  const filteredfieldCodeData = fieldCodeData.filter((each) => each.fieldCode != 'DBUDWFIELDS');

  const modeOptions = [{value: 'Test'}, {value: 'Update'}];

  const getValue = (values) => {
    const a = values?.split(' ')?.join('');
    const dateValue = values?.length > 1 ? values?.slice(0, 5) :'';
    if (dateValue?.toUpperCase() === 'TODAY') {
      return a?.replace(dateValue, 'cast(now()as date)');
    } else if (values?.charAt(0)?.toUpperCase() === 'T') {
      return a?.replace(values?.charAt(0), 'cast(now()as date)');
    } else {
      return values;
    }
  };

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.fieldCode === option || item.key === option || item.value === option) {
          label = item;
        }
      });
    return label;
  };

  const initialVal = {
    accessMethod: rowData?.accessType ? getObject(rowData?.accessType, fieldCodeData) : '',
    action: rowData?.action ? rowData?.action : actionData ? actionData[0] : '',
    mode: rowData?.mode ? getObject(rowData?.mode, modeOptions) : {value: 'Test'},
  };
  const [initialValues, setInitialValues] = useState(initialVal);

  const [data, setData] = useState({});
  const [fieldCodeValue, setFieldCodeValue] = useState({});
  useEffect(() => {
    const initial = {
      accessMethod: formRef?.current?.values?.accessMethod?.fieldCode ? getObject(formRef?.current?.values?.accessMethod?.fieldCode, fieldCodeData) : '',
      action: formRef?.current?.values?.action ? formRef?.current?.values?.action :'', // actionData ? actionData[0]
      mode: formRef?.current?.values?.mode?.value ? getObject(formRef?.current?.values?.mode?.value, modeOptions) : {value: 'Test'},
    };
    setInitialValues(initial);
  }, [actionData, fieldCodeData]);
  useEffect(() => {
    (fieldCodeValue?.fieldCode || rowData?.accessType) &&
      dispatch(
        getActions(fieldCodeValue?.fieldCode ? fieldCodeValue?.fieldCode : rowData?.accessType),
      );
  }, [fieldCodeValue?.fieldCode, rowData?.accessType]);
  useEffect(() => {
    setTimeout(() => {
      setData(rowData);
    }, 1500);
  }, [rowData]);

  useEffect(() => {
    if (rowData?.accessType) {
      dispatch(
        postFieldCode({
          fieldCode: rowData.accessType,
          options: rowData?.action,
        }),
      );
    }
  }, [rowData]);
  const getArrayData = (selectedAccessMethod, data) => {
    if (selectedAccessMethod === 'DBCOLLECTOR') {
      return data?.collectors && data?.collectors.length > 0 ?
        data.collectors.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSDISP') {
      return data?.disposition && data?.disposition.length > 0 ?
        data.disposition.map((i) => {
          return i.valueCode;
        }) :
        [];
    } else if (selectedAccessMethod === 'DBCLNT') {
      return data?.client && data?.client.length > 0 ?
        data.client.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSSTAT') {
      return data?.phase && data?.phase.length > 0 ? data.phase.map((i) => i?.valueCode) : [];
    } else {
      return [];
    }
  };

  const onSubmit = (data) => {
    const selectedAccessMethod = data?.accessMethod?.fieldCode;
    const singleData = data.Date;
    const payload = {
      accessMethodRequest: {
        accessMethod: data?.accessMethod?.fieldCode ? data?.accessMethod?.fieldCode : '',
        endDate:
          data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
          data?.lastDate &&
          !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(data?.lastDate)
            getValue(data?.lastDate) :
            '',
        action: data?.action ? data?.action : '',
        startDate:
          data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
          singleData &&
          !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(singleData)
            getValue(data?.Date) :
            data?.accessMethod?.fieldCode === 'DBLSTDTE' && data?.startDate ? // ? getFormattedDate(data?.startDate)
              getValue(data?.startDate) :
              '',
        value:
          data?.accessMethod?.fieldCode === 'DBLSTDTE' ||
          ['Is Blank', 'Is Not Blank']?.includes(data?.action) ?
            [] :
            getArrayData(selectedAccessMethod, data),
      },
      groupCode: rowData?.groupCode ? rowData?.groupCode : '',
      triggerGroupId: rowData?.triggerGroupId ? rowData?.triggerGroupId : '',
      mode: data?.mode?.value ? data?.mode?.value : 'Test',
    };
    dispatch(postRunReport(payload));
  };
  const validationSchema = yup.object().shape({
    mode: yup.mixed().test('mode', 'Mode is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    accessMethod: yup.mixed().test('accessMethod', 'Filter Method is required', (value) => {
      if (!value?.fieldCode) {
        return false;
      } else {
        return true;
      }
    }),
    disposition:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DSDISP' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      yup.array().test('dispo', 'Status is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    // .notOneOf(["none"], "Continue prev task failure is required")
    // .required("Disposition is required")
    // .nullable(),
    collectors:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBCOLLECTOR' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      yup.array().test('collector', 'Collector is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    phase:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DSSTAT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      yup.array().test('phase', 'Phase is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    client:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBCLNT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      yup.array().test('client', 'Client is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    Date:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['<', '>'].includes(formRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      // yup.date().typeError().nullable().required("Date is required"),
      yup?.mixed().test('Date', 'Values is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    startDate:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      // yup.date().typeError().nullable().required("Start date is required"),
      yup.mixed().test('startDate', 'From Values is required', (val) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    lastDate:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      // yup
      //   .date()
      //   .typeError()
      //   .nullable()
      //   .required("End date is required")
      //   .min(yup.ref("startDate"), "End date should be greater than start date"),
      yup.mixed().test('lastDate', 'To Values is required', (val) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    action:
      formRef?.current?.values?.accessMethod?.fieldCode !== 'DBACCT' &&
      yup
        .string()
      // .notOneOf(["none"], "Continue prev task failure is required")
        .required('Action is required')
        .nullable(),
  });
  return (
    <>
      <Formik
        onSubmit={(values) => onSubmit(values)}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        innerRef={formRef}
        initialTouched={{
          field: true,
        }}
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            errors,
            touched,
          } = props;
          return (
            <>
              <Form autoComplete="off" noValidate>
                <div className="new-standard-textfields global-field-textfields">
                  <div className={classes.dialoguecardStyles}>
                    <div className="form-row">
                      <div className=" col-md-12 mb-1">
                        <BreadCrums
                          name={'Batch Trigger Name'}
                          code={rowData?.groupCode}
                          description={'Description'}
                          descriptionValue={rowData?.groupDescription}
                        />
                        {/* <Typography variant="h4">Trigger  : {rowData?.groupCode} - {rowData?.groupDescription}</Typography> */}
                      </div>
                    </div>
                    <div className={`form-row border-bottom mb-3`}>
                      <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="mode"
                          id="mode"
                          size="small"
                          options={modeOptions}
                          required
                          value={values.mode}
                          getOptionLabel={(option) => {
                            return option && option.value;
                          }}
                          onChange={(_, data) => {
                            // handleChange(e);
                            // setFieldValue("mode", value);
                            setFieldCodeValue(data);
                            setFieldValue('mode', data);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                label="Mode"
                                placeholder="Select Mode"
                                required
                                error={touched.mode && errors.mode}
                              />
                            </div>
                          )}
                        />
                        <FormHelperText>
                          {touched.mode && errors.mode && errors.mode}
                        </FormHelperText>
                      </div>
                      <div className={`col-sm-6 col-md-4 col-xl-3 form-group`}>
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="accessMethod"
                          id="accessMethod"
                          size="small"
                          value={values?.accessMethod}
                          options={filteredfieldCodeData}
                          getOptionDisabled={(option) => option.valueCode === null}
                          getOptionLabel={(option) => {
                            return option && option?.description ? option?.description : '';
                          }}
                          required
                          onChange={(_, data) => {
                            setSubmitted(false);
                            setFieldCodeValue(data);
                            setFieldValue('accessMethod', data);
                            setFieldValue('action', '');
                            data?.fieldCode &&
                              dispatch(
                                postFieldCode({
                                  fieldCode: data?.fieldCode,
                                  options: values?.action || '',
                                }),
                              );
                          }}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                fullWidth
                                margin="dense"
                                label="Filter Method"
                                name="accessMethod"
                                required
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                error={Boolean(touched.accessMethod && errors.accessMethod)}
                                placeholder="Select Filter Method"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            </div>
                          )}
                        />
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched?.accessMethod && errors?.accessMethod && errors?.accessMethod}
                        </FormHelperText>
                      </div>
                      {values?.accessMethod?.fieldCode &&
                        values?.accessMethod?.fieldCode !== 'DBACCT' && (
                        <>
                          <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group">
                            <GuiAutoComplete
                              classes={{
                                option: classes.option,
                              }}
                              name="action"
                              id="action"
                              size="small"
                              value={values?.action}
                              options={actionData}
                              disabled={fieldCodeValue?.fieldCode === 'DBACCT'}
                              getOptionLabel={(option) => {
                                return option ? option : '';
                              }}
                              required
                              onChange={(_, data) => {
                                setFieldValue('action', data);
                                values?.accessMethod?.fieldCode &&
                                    data &&
                                    dispatch(
                                      postFieldCode({
                                        fieldCode: values?.accessMethod?.fieldCode,
                                        options: data,
                                      }),
                                    );
                              }}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    margin="dense"
                                    className={` ${classes.labelName}`}
                                    {...params}
                                    variant="outlined"
                                    // InputLabelProps={{
                                    //   shrink: true,
                                    // }}
                                    required
                                    error={Boolean(touched.action && errors.action)}
                                    fullWidth
                                    label="Action"
                                    name="action"
                                    placeholder="Select Action"
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: 'off',
                                    }}
                                  />
                                </div>
                              )}
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched?.action && errors?.action && errors?.action}
                            </FormHelperText>
                          </div>

                          {values?.action && (
                            <div className="col-sm-6 col-md-4 col-lg-4 d-flex">
                              <GetAccessMethodFields
                                values={values}
                                formProps={props}
                                setFieldValue={setFieldValue}
                                accessMethodFields={promptData}
                                fieldCodeValue={fieldCodeValue}
                                additionalInfoData={data}
                                fieldSubmitted={fieldSubmitted}
                                setSubmitted={setSubmitted}
                              />
                            </div>
                          )}
                        </>
                      )}
                    </div>

                    <div className="row justify-content-center">
                      <Button
                        variant="outlined"
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          setInitialValues(initialVal);
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot} `}
                        onClick={() => {
                          setSubmitted(true);
                          if (formRef.current.isValid) {
                            setSubmitted(false);
                          }
                        }}
                      >
                        Run
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
    </>
  );
};

export default RunTriggerGroup;
